import type { PackageManager } from '@cli-types/core-engine/utils.js'
import { buildAddDependencyArgs } from './build-add-dependency-args.js'
import { execFileAsync } from './exec-file-async.js'

export async function installDependency(
  cwd: string,
  pm: PackageManager,
  dependency: string,
  dev = false
): Promise<boolean> {
  try {
    await execFileAsync(pm, buildAddDependencyArgs(pm, dependency, dev), { cwd })
    return true
  } catch {
    return false
  }
}
